import React, { useRef } from "react";
import styles from "./Keypad.module.css";

const KEYS = [
  { digit: "1", sub: "" },
  { digit: "2", sub: "ABC" },
  { digit: "3", sub: "DEF" },
  { digit: "4", sub: "GHI" },
  { digit: "5", sub: "JKL" },
  { digit: "6", sub: "MNO" },
  { digit: "7", sub: "PQRS" },
  { digit: "8", sub: "TUV" },
  { digit: "9", sub: "WXYZ" },
  { digit: "*", sub: "" },
  { digit: "0", sub: "+" },
  { digit: "#", sub: "" },
];

const Keypad = ({ onPress, onLongPressZero }) => {
  const pressTimerRef = useRef(null);
  const firedRef = useRef(false);

  // Long-press 0 types "+" — the standard phone-keypad shortcut.
  const startPress = (digit) => {
    if (digit !== "0" || !onLongPressZero) return;
    firedRef.current = false;
    pressTimerRef.current = setTimeout(() => {
      firedRef.current = true;
      onLongPressZero();
    }, 500);
  };

  const endPress = (digit) => {
    if (digit !== "0" || !onLongPressZero) {
      onPress(digit);
      return;
    }
    clearTimeout(pressTimerRef.current);
    pressTimerRef.current = null;
    if (firedRef.current) {
      firedRef.current = false;
      return;
    }
    onPress(digit);
  };

  return (
    <div className={styles.keypad}>
      {KEYS.map((k) => (
        <button
          key={k.digit}
          type="button"
          className={styles.key}
          aria-label={k.digit}
          onMouseDown={() => startPress(k.digit)}
          onTouchStart={() => startPress(k.digit)}
          onMouseUp={() => endPress(k.digit)}
          onTouchEnd={(e) => {
            e.preventDefault();
            endPress(k.digit);
          }}
        >
          <span className={styles.digit}>{k.digit}</span>
          <span className={styles.sub}>{k.sub || " "}</span>
        </button>
      ))}
    </div>
  );
};

export default Keypad;
